import type { IRichText } from '@belong/types';
import type { Document } from '@contentful/rich-text-types';

export const FRichText = (data: Document, contentId?: string): IRichText => ({
  html: data,
  contentId
});
